module.exports = __webpack_public_path__ + "src/assets/textures/petri/wax_tape_lambert1_AO.jpg";